import ChangeUrl from "../../change-url/presenter/change-url.js";

import {
  sendXhrQueue
} from "../../../utils/send-xhr/send-xhr.js";

import {
  RequestAction,
  CONNECTOR_URL,
  PAGINATION_KEY,
  LIMIT_KEY,
  SORT_KEY,
  VIEW_TYPE_KEY,
  ViewType,
  PROPERTIES_SEPARATOR
} from "../const.js";
export default class ChangeFilter {
  constructor() {
    this._changeUrl = new ChangeUrl();

    this._filterFormElement = null;
    this._inputsElements = [];
    this._filterModel = null;

    this._observers = {
      start: [],
      load: [],
      end: []
    };

    this._requestQueue = {};
  }

  changeUrl(params, url, replace = false) {
    this._changeUrl.change(params, url, replace);
  }

  setFilterFormElement(element) {
    this._filterFormElement = element;
  }

  setInputElements(elements) {
    this._inputsElements = elements;
  }

  setFilterModel(filterModel) {
    this._filterModel = filterModel;
  }

  addLoadStartObserver(observer) {
    this._observers.start.push(observer);
  }

  addLoadObserver(observer) {
    this._observers.load.push(observer);
  }

  addLoadEndObserver(observer) {
    this._observers.end.push(observer);
  }

  removeLoadObserver(observer) {
    this._observers.load = this._observers.load.filter((existedObserver) => existedObserver !== observer);
  }

  removeLoadEndObserver(observer) {
    this._observers.end = this._observers.end.filter((existedObserver) => existedObserver !== observer);
  }

  updateProductsData(options = {}) {
    // Defining the body container for all properties.
    const body = [];
    body.push(`action=${RequestAction.LOAD_PRODUCTS}`);

    // Defining the current state properties.
    let currentStateParams = {};

    // Temporary enabling disabled fields so they can be sent collected via the `new FormData()`.
    Array.from(this._inputsElements)
      .filter((element) => element.disabled === true)
      .forEach((element) => {
        element.disabled = false;
        element.readonly = true;
      });

    // Getting the form values.
    const formData = Array
      .from(new FormData(this._filterFormElement));
    let query = {};

    // Disabling temporary enabled fields
    Array.from(this._inputsElements)
      .filter((element) => element.readonly === true)
      .forEach((element) => {
        element.disabled = true;
        element.readonly = false;
      });

    formData.forEach((item) => {
      if (item[1] === ``) {
        return;
      }

      if (!query[item[0]]) {
        query[item[0]] = [];
        query[item[0]].push(encodeURIComponent(item[1]));
      } else {
        query[item[0]].push(encodeURIComponent(item[1]));
      }
    });

    if (Object.keys(query).length !== 0) {
      body.push(`query=${JSON.stringify(query)}`);

      currentStateParams = Object.assign(
          {},
          query
      );
    }

    // Getting the search query parts.
    const searchParts = document.location.search
      .replace(/^\?/, ``)
      .split(`&`);

    // Gettings the pagination value.
    if (options.page) {
      body.push(`${PAGINATION_KEY}=${options.page}`);
      currentStateParams[PAGINATION_KEY] = options.page;
    }

    // Loading data via the load button.
    if (options.byButton) {

      // Calculating a new page number.
      const pageGroups = document.location.search.match(/page=(\d+)/i);
      const currentPage = (pageGroups && pageGroups[1]) ? +pageGroups[1] : 1;
      const newPage = currentPage + 1;

      body.push(`${PAGINATION_KEY}=${newPage}`);
      currentStateParams[PAGINATION_KEY] = newPage;
      body.push(`by_button=${true}`);
    }

    // Getting the sorting part.
    if (options.sort) {
      body.push(`${SORT_KEY}=${options.sort}`);
      currentStateParams[SORT_KEY] = options.sort;
    }

    // If there is no sorting option specified.
    if (!options.sort && options.sort !== ``) {
      const sortingPart = searchParts
        .filter((item) => {
          item = item.split(`=`);
          return item[0] === SORT_KEY;
        })
        .join(``);

      if (sortingPart) {
        body.push(sortingPart);
        currentStateParams[SORT_KEY] = sortingPart.split(`=`)[1];
      }
    }

    // Getting the category view type part.
    if (options.view && options.view !== ViewType.CARD) {
      body.push(`${VIEW_TYPE_KEY}=${options.view}`);
      currentStateParams[VIEW_TYPE_KEY] = options.view;
    }

    // If there is no view type option specifed.
    if (!options.view) {
      const viewTypePart = searchParts
        .filter((item) => {
          item = item.split(`=`);
          return item[0] === VIEW_TYPE_KEY;
        })
        .join(``);

      if (viewTypePart) {
        body.push(viewTypePart);
        currentStateParams[VIEW_TYPE_KEY] = viewTypePart.split(`=`)[1];
      }
    }

    // Getting the limit part.
    const limitPart = searchParts
      .filter((item) => {
        item = item.split(`=`);
        return item[0] === LIMIT_KEY;
      })
      .join(``);

    if (limitPart && Object.keys(query).length !== 0) {
      body.push(limitPart);
      currentStateParams[LIMIT_KEY] = +limitPart.split(`=`)[1];
    }

    // Getting the URI property
    const uri = [];

    if (Object.keys(query).length !== 0) {
      uri.push(Object.entries(query)
        .map(([key, value]) => `${key}=${encodeURIComponent(value.join(PROPERTIES_SEPARATOR))}`)
        .join(`,`));
    }

    if (limitPart) {
      uri.push(limitPart);
    }

    const uriFull = [];
    uriFull.push(document.location.pathname);
    uriFull.push(uri.join(`,`));

    body.push(`uri=${JSON.stringify(uriFull.join(`?`))}`);

    // Preparing the current state properties
    currentStateParams = Object
      .entries(currentStateParams)
      .map((item) => {
        return (typeof item[1] === `object`) ?
          `${item[0]}=${item[1].join(PROPERTIES_SEPARATOR)}` :
          `${item[0]}=${item[1]}`;
      });

    const args = {
      body,
      connectorUrl: CONNECTOR_URL,
      loadstartCallback: () => {
        this._notifyLoadStart();
      },
      loadCallback: (response) => {
        const preparedResponse = JSON.parse(response);

        if (!options.preventUrlChange) {
          const url = (currentStateParams.length > 0) ?
            `${document.location.origin}${document.location.pathname}?${currentStateParams.join(`&`)}` :
            `${document.location.origin}${document.location.pathname}`;

          if (!preparedResponse.seo_filter) {
            this._changeUrl.change(currentStateParams, url);
          }
        }

        this._notifyLoad(preparedResponse, options);
      },
      loadendCallback: () => {
        this._notifyLoadEnd();
      },
      requestQueue: this._requestQueue
    };

    sendXhrQueue(args);
  }

  _notifyLoadStart() {
    this._observers.start.forEach((observer) => observer());
  }

  _notifyLoad(data, options = {}) {
    this._observers.load.forEach((observer) => observer(data, options));
  }

  _notifyLoadEnd() {
    this._observers.end.forEach((observer) => observer());
  }
}
